import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { Transition } from 'react-spring';
import { StateConsumer } from './State';
import Breakpoint from './Breakpoint';

const MenuOverHang = styled.div`
  width: 100%;
  height: 100%;
  background-image: linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.9));
  background-blend-mode: multiply;
  padding: 2rem 1rem;
  z-index: 90;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media screen and (max-width: 360px) {
    padding: 0.5rem 1rem;
  }
`;

const Info = styled.p`
  width: 5em;
  font-family: ${props => props.theme.font.displayFontFamily};
  font-size: 1.5rem;
  color: ${props => props.theme.colors.white};
  line-height: 1.2;
  letter-spacing: 2px;
  mark {
    background: transparent;
    color: ${props => props.theme.colors.grey};
    font-size: 1.8em;
  }
  @media screen and (max-height: 650px) {
    font-size: 1rem;
  }
  @media screen and (max-height: 320px) {
    font-size: 0.8rem;
    width: 80%;
  }
`;

const Nav = styled.ul`
  display: flex;
  flex-direction: column;
`;

const NavItems = styled.li`
  margin: 1rem 0;

  a {
    text-decoration: none;
    text-transform: uppercase;
    font-size: 2rem;
  }
  @media screen and (max-height: 700px) {
    a {
      font-size: 1.8rem;
    }
  }
  @media screen and (max-height: 670px) {
    margin: 0.5rem 0;
    a {
      font-size: 1.5rem;
    }
  }
`;

const AboutText = styled.p`
  width: 100%;
  line-height: 1.5;
`;

const Menu = () => (
  <Breakpoint
    test={{
      target: 'height',
      value: 500,
      targetIs: 'lt',
    }}
  >
    {islt500 => (
      <StateConsumer>
        {({ state, actions }) => (
          <Transition
            from={{
              position: 'fixed',
              top: 0,
              right: 0,
              maxWidth: '500px',
              height: '100vh',
              transform: 'translateX(100%)',
              zIndex: '200',
            }}
            enter={{ transform: 'translateX(0)' }}
            leave={{
              transform: 'translateX(100%)',
              pointerEvents: 'none',
            }}
          >
            {state.menuOpen &&
              (styles => (
                <div style={styles}>
                  <MenuOverHang styles={styles}>
                    <Info>
                      minimum days to delivery <mark>60</mark>
                    </Info>
                    <Nav>
                      <NavItems>
                        <Link to="/about" onClick={actions.toggleMenu}>
                          About Us.
                        </Link>
                      </NavItems>
                      <NavItems>
                        <Link to="/collection" onClick={actions.toggleMenu}>
                          Collection.
                        </Link>
                      </NavItems>
                      <NavItems>
                        <Link to="/customise" onClick={actions.toggleMenu}>
                          Customise.
                        </Link>
                      </NavItems>
                      <NavItems>
                        <Link to="/contact" onClick={actions.toggleMenu}>
                          Contact Us.
                        </Link>
                      </NavItems>
                    </Nav>
                    {!islt500 && (
                      <AboutText>
                        Tronc&co. was born with the idea of bringing a sense of the whimsical and romantic to the
                        otherwise “functional” world of storage .
                      </AboutText>
                    )}
                  </MenuOverHang>
                </div>
              ))}
          </Transition>
        )}
      </StateConsumer>
    )}
  </Breakpoint>
);

export default Menu;
